






















































































































import { EquipmentModel, EquipmentsApi } from "../../../apis";
import { Component, Vue } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import AddEquipment from "./AddEquipment.vue";
import { ACTION } from ".";
import * as FileSaver from "file-saver";
import { VueExcelEco2 } from "../common/VueExcelEco2";

@Component({
  components: {
    MoreVertBtn,
    AddEquipment,
  },
})
export default class EquipmentMaintenanceTab extends Vue {
  searchText = "";
  showAddEditEquipmentDialog = false;
  showDeleteEquipmentDialog = false;
  showResetOperatingTimeDialog = false;
  selectedEquipment: EquipmentModel | null = null;
  equipments: EquipmentModel[] = [];
  mode: ACTION = ACTION.ADD;
  pagingOption: DataOptions | null = null;
  totalItems = 0;

  get ACTIONS(): Array<IAction> {
    return [
      {
        titleName: this.$t("text.edit"),
        action: ACTION.EDIT,
      },
      {
        titleName: this.$t("text.resetOperatingTime"),
        action: ACTION.RESET_OPERATING_TIME,
      },
      {
        titleName: this.$t("text.delete"),
        action: ACTION.DELETE,
        titleStyle: "color: red",
      },
    ];
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }
  get addEquipmentClick() {
    return this.$store.getters.addEquipmentClick;
  }

  get HEADERS() {
    return [
      {
        text: this.$t("text.customer"),
        align: "start",
        value: "customer.companyName",
        class: ["tw-whitespace-no-wrap"],
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("text.location"),
        value: "location.locationName",
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("text.unit"),
        value: "unit.name",
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("equipment.equipmentName"),
        value: "equipmentName",
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("text.variable"),
        value: "variable.variableName",
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("equipment.totalTime"),
        value: "totalTime",
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("equipment.operatingTime"),
        value: "operatingTime",
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("equipment.remainingTime"),
        value: "remainingTime",
      },
      {
        class: ["tw-whitespace-no-wrap"],
        text: this.$t("equipment.file"),
        value: "attachFileNames",
        sortable: false,
      },
      {
        text: this.$t("locationColumn.action"),
        value: "action",
        sortable: false,
        class: ["tw-whitespace-no-wrap"],
      },
    ] as DataTableHeader[];
  }

  dataExport = [];

  columnsExport = [
    {
      label: this.$t("text.customer"),
      field: "customer.companyName",
    },
    {
      label: this.$t("text.location"),
      field: "location.locationName",
    },
    {
      label: this.$t("text.unit"),
      field: "unit.name",
    },
    {
      label: this.$t("equipment.equipmentName"),
      field: "equipmentName",
    },
    {
      label: this.$t("text.variable"),
      field: "variable.variableName",
    },
    {
      label: this.$t("equipment.totalTime"),
      field: "totalTime",
    },
    {
      label: this.$t("equipment.operatingTime"),
      field: "operatingTime",
    },
    {
      label: this.$t("equipment.remainingTime"),
      field: "remainingTime",
    },
  ];


  updated() {
    const btnAddEquipment = document.querySelector(
      ".button-add-equipment"
      ) as HTMLButtonElement;
      if (btnAddEquipment) {
        btnAddEquipment.onclick = () => {
          this.showAddEditEquipmentDialog = true;
          this.mode = ACTION.ADD;
        };
      }
    const btnExportEquipment = document.querySelector(
      ".button-export-equipment"
      ) as HTMLButtonElement;
      if (btnExportEquipment) {
        btnExportEquipment.onclick = async () => {
          this.$util.showLoading();
          try {
            const res = await new EquipmentsApi().exportEquipments({
              keySearch: this.searchText,
              orderBy: this.pagingOption.sortBy.length > 0 ? this.pagingOption.sortBy[0] : "",
              orderDesc: this.pagingOption.sortDesc.length > 0 ? "" + this.pagingOption.sortDesc[0] : "",
            });
            this.dataExport = res.data.data;
          } catch (error) {
            this.$util.showError(error);
          } finally {
            new VueExcelEco2(
              "ECO2 - Export Equipment",
              "xlsx",
              "ECO2 Web",
              this.dataExport,
              this.columnsExport
            ).exportExcel();
            this.$util.hideLoading();
          }
        };
      }
  }

  onSelectedAction(item: EquipmentModel, action: ACTION): void {
    this.selectedEquipment = { ...item };
    this.mode = action;
    switch (action) {
      case ACTION.EDIT: {
        this.showAddEditEquipmentDialog = true;
        break;
      }
      case ACTION.DELETE: {
        this.showDeleteEquipmentDialog = true;
        break;
      }
      case ACTION.RESET_OPERATING_TIME: {
        this.showResetOperatingTimeDialog = true;
        break;
      }
      default: {
        break;
      }
    }
  }

  onPagingOption() {
    this.doSearch();
  }

  onDownloadFile(item: EquipmentModel, fileName: string) {
    this.$util.showLoading();
    new EquipmentsApi()
      .downloadAttachFile({ id: item.id, fileName: fileName }, { responseType: "blob" })
      .then((resp) => {
        FileSaver.saveAs(resp.data as any, fileName);
        this.$util.hideLoading();
      })
      .catch((error) => {
        this.$util.showError(error);
        this.$util.hideLoading();
      });
  }

  async onDeleteEquipmentDialog() {
    this.$util.showLoading();
    try {
      await new EquipmentsApi().deleteEquipment({
        id: this.selectedEquipment.id,
      });
      this.showDeleteEquipmentDialog = false;
      this.doSearch();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onResetOperatingTimeDialog() {
    this.$util.showLoading();
    try {
      await new EquipmentsApi().resetOperatingTime({
        id: this.selectedEquipment.id,
      });
      this.showResetOperatingTimeDialog = false;
      this.doSearch();
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async doSearch() {
    this.$util.showLoading();
    try {
      const rs = await new EquipmentsApi().searchEquipments({
        keySearch: this.searchText,
        page: this.pagingOption.page,
        limit: this.pagingOption.itemsPerPage,
        orderBy:
          this.pagingOption.sortBy.length > 0
            ? this.pagingOption.sortBy[0]
            : "",
        orderDesc:
          this.pagingOption.sortDesc.length > 0
            ? "" + this.pagingOption.sortDesc[0]
            : "",
      });

      this.totalItems = rs.data.count;
      this.equipments = rs.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }
}
